import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LinkedinIcon } from 'lucide-react';
export function About() {
  const credibility = ['Former product leader at NBC, Yahoo, Evite, and Friendster', 'Designed and piloted an AI-assisted career coaching program at ASU', 'Hiring manager and team leader across consumer web, mobile, social, and AI', 'Training through Youth Coaching Institute and ScholarMatch', 'Mentored new grads and emerging talent through career launch and beyond'];
  return <section id="about" className="py-20 md:py-24 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-10">
      <div className="grid md:grid-cols-12 gap-12 items-start" data-id="element-11">
        {/* Photo + identity */}
        <div className="md:col-span-4 flex flex-col items-center md:items-start" data-id="element-12">
          <img src="https://cdn.magicpatterns.com/uploads/rHY1f3YTu8xTAzKyKufzyh/profile-larissa.jpg" alt="Larissa, founder of Year One Mentor" className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover shadow-sm" data-id="element-13" />
          <div className="mt-5 text-center md:text-left" data-id="element-14">
            <p className="font-serif text-2xl text-ink" data-id="element-15">Larissa</p>
            <p className="text-sm text-ink/60" data-id="element-16">Founder, Year One Mentor</p>
            <a href="https://www.linkedin.com/in/larissa/" target="_blank" rel="noopener noreferrer" aria-label="Visit Larissa's LinkedIn profile" className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-teal/20 text-teal text-xs font-medium hover:bg-teal hover:text-white hover:border-teal transition-colors" data-id="element-17">
              <LinkedinIcon className="w-3.5 h-3.5" data-id="element-18" />
              <span data-id="element-19">Connect on LinkedIn</span>
            </a>
          </div>
        </div>

        {/* Story teaser */}
        <div className="md:col-span-8" data-id="element-20">
          <p className="text-xs uppercase tracking-widest text-accent mb-3 font-medium" data-id="element-21">
            Why I started Year One
          </p>
          <h2 className="text-4xl md:text-5xl font-serif mb-6 leading-[1.1]" data-id="element-22">
            One conversation can change everything
            <span className="text-accent" data-id="element-23">.</span>
          </h2>

          <div className="space-y-4 text-lg text-ink/80 leading-relaxed font-light" data-id="element-24">
            <p className="font-serif text-[22px] text-ink italic leading-snug" data-id="element-25">
              I was the underdog from the start.
            </p>
            <p data-id="element-26">
              I flunked my first year of college and was told I would probably
              end up working at McDonald's. While working retail, I met a
              customer who worked at NBC — I followed up, and that one
              conversation launched my career in tech.
            </p>
          </div>

          <Link to="/about" className="mt-6 inline-flex items-center gap-1.5 text-teal font-medium hover:text-teal/70 transition-colors group" data-id="element-27">
            <span className="border-b border-teal/40 group-hover:border-teal/70" data-id="element-28">
              Read my full story
            </span>
            <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" data-id="element-29" />
          </Link>

          <div className="mt-10 bg-white p-7 rounded-2xl border border-teal/10 shadow-sm" data-id="element-30">
            <h3 className="text-base font-serif mb-4 text-teal uppercase tracking-wider" data-id="element-31">
              Experience & Credibility
            </h3>
            <ul className="space-y-3" data-id="element-32">
              {credibility.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-ink/70" data-id="element-33">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" data-id="element-34"></div>
                  <span data-id="element-35">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}